import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categoryArticles } from '@/mocks/data';

const allTags = Array.from(new Set(categoryArticles.flatMap((a) => a.tags)));

export default function Articles() {
  const [activeTag, setActiveTag] = useState<string | null>(null);

  const filteredArticles = activeTag
    ? categoryArticles.filter((a) => a.tags.includes(activeTag))
    : categoryArticles;

  return (
    <>
      <SEOHead
        title="精品文章 - 太阳娱乐 | 娱乐资讯与深度分析"
        description="太阳娱乐精品文章频道为您提供电子竞技、娱乐资讯、体育赛事、游戏推荐等多元化的深度文章内容。专业编辑团队精心打造，为您带来高质量的阅读体验。"
        keywords="太阳娱乐,精品文章,娱乐资讯,电竞赛事,体育新闻,游戏推荐"
      />
      <SchemaOrg type="WebPage" data={{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: '精品文章 - 太阳娱乐',
        url: 'https://hznaweisi.cn/articles',
        description: '太阳娱乐精品文章频道，涵盖电竞、娱乐、体育、游戏等多元内容。',
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb />

          <section className="py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center mb-8">
                <h1 className="text-2xl md:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  精品文章
                </h1>
                <p className="text-foreground-600 mt-2">深度好文，带您领略娱乐世界的精彩与魅力</p>
              </div>

              <div className="flex items-center justify-center gap-2 flex-wrap">
                <button
                  onClick={() => setActiveTag(null)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeTag === null
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  全部
                </button>
                {allTags.map((tag) => (
                  <button
                    key={tag}
                    onClick={() => setActiveTag(tag === activeTag ? null : tag)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      activeTag === tag
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredArticles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/articles/${article.slug}`}
                    className="group block bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <div className="relative overflow-hidden aspect-[16/10]">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute top-3 left-3 flex gap-2">
                        {article.tags.slice(0, 2).map((tag) => (
                          <span
                            key={tag}
                            className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                        <span>{article.date}</span>
                        <span>·</span>
                        <span>{article.readTime}阅读</span>
                        <span>·</span>
                        <span>{article.views.toLocaleString()} 浏览</span>
                      </div>
                      <h2 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                    </div>
                  </Link>
                ))}
              </div>

              {filteredArticles.length === 0 && (
                <div className="text-center py-16">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-600">没有找到相关文章</p>
                </div>
              )}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}